import { useState } from 'react';

import { cn } from '~/shared/lib/cn.ts';
import { LinkTypes } from '~/shared/model/link-types.ts';
import { BurgerIcon } from '~/shared/ui/burger-icon';
import { NavLinks } from '~/shared/ui/nav-links';
import { Popover, PopoverContent, PopoverTrigger } from '~/shared/ui/popover';

type BurgerMenuProperties = {
  linkType: LinkTypes;
};

export function BurgerMenu({ linkType }: BurgerMenuProperties) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="lg:hidden">
      <Popover onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <div className="flex w-7 cursor-pointer flex-col gap-1.5 text-3xl text-primary">
            <BurgerIcon isOpen={isOpen} />
          </div>
        </PopoverTrigger>

        <PopoverContent className={cn('mr-4 mt-2')}>
          <div className="flex w-40 flex-col gap-4 rounded-l-lg bg-background px-4 py-2">
            <NavLinks
              onLinkClick={() => setIsOpen(false)}
              linkType={linkType}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
